/**
 * GENERATED FILE — DO NOT EDIT BY HAND.
 * Written by scripts/generate-ssg-routes.mjs on every route regeneration, from the
 * SAME register + gym data that decides which pages get built. Edit that script, not
 * this file; a hand-edit here moves page URLs without moving the pages.
 *
 * Maps a state's BARE location slug (the postcode-less output of toLocationSlug) to
 * the ONE postcode that suburb's pages are addressed at — see lib/suburbPostcode.mjs
 * for why this is resolved per suburb page rather than per gym record.
 *
 * Consumed by lib/stateCore.mjs (`toAddressedLocationSlug`), which every URL builder
 * routes through, so the build, the generators and the browser mint one address.
 */
export const SUBURB_POSTCODES = Object.freeze({
    "nsw": Object.freeze({
        "acacia-gardens": "2763",
        "adamstown": "2289",
        "albion-park": "2527",
        "albion-park-rail": "2527",
        "albury": "2640",
        "alexandria": "2015",
        "anna-bay": "2316",
        "annandale": "2038",
        "annangrove": "2156",
        "appin": "2560",
        "armidale": "2350",
        "arncliffe": "2205",
        "arndell-park": "2148",
        "artarmon": "2064",
        "ashcroft": "2168",
        "ashfield": "2131",
        "auburn": "2144",
        "austral": "2179",
        "avalon-beach": "2107",
        "balgowlah": "2093",
        "ballina": "2478",
        "balmain": "2041",
        "bangalow": "2479",
        "banksia": "2216",
        "bankstown": "2200",
        "banora-point": "2486",
        "bardia": "2565",
        "barrack-heights": "2528",
        "bateau-bay": "2261",
        "batemans-bay": "2536",
        "bathurst": "2795",
        "baulkham-hills": "2153",
        "beacon-hill": "2100",
        "beecroft": "2119",
        "bega": "2550",
        "bella-vista": "2153",
        "bellambi": "2518",
        "bellbird": "2325",
        "bellevue-hill": "2023",
        "bellingen": "2454",
        "belmont-north": "2280",
        "belmore": "2192",
        "bennetts-green": "2290",
        "beresfield": "2322",
        "berkeley-vale": "2261",
        "berowra-heights": "2082",
        "berry": "2535",
        "beverly-hills": "2209",
        "bexley": "2207",
        "bilambil": "2486",
        "bilambil-heights": "2486",
        "blacktown": "2148",
        "blaxland": "2774",
        "boambee": "2450",
        "bogangar": "2488",
        "bomaderry": "2541",
        "bondi": "2026",
        "bondi-beach": "2026",
        "bondi-junction": "2022",
        "bonnet-bay": "2226",
        "bonny-hills": "2445",
        "boolaroo": "2284",
        "boorowa": "2586",
        "bossley-park": "2176",
        "botany": "2019",
        "bourke": "2840",
        "bowral": "2576",
        "bradbury": "2560",
        "braidwood": "2622",
        "broadmeadow": "2292",
        "broken-hill": "2880",
        "brookvale": "2100",
        "budgewoi": "2262",
        "bulli": "2516",
        "buronga": "2739",
        "burringbar": "2483",
        "burwood": "2134",
        "burwood-heights": "2136",
        "byron-bay": "2481",
        "cabarita-beach": "2488",
        "cabramatta": "2166",
        "caddens": "2747",
        "cambridge-park": "2747",
        "camden": "2570",
        "cameron-park": "2285",
        "cammeray": "2062",
        "campbelltown": "2560",
        "camperdown": "2050",
        "campsie": "2194",
        "canley-heights": "2166",
        "canley-vale": "2166",
        "canterbury": "2193",
        "cardiff": "2285",
        "caringbah": "2229",
        "carlingford": "2118",
        "carlton": "2218",
        "casino": "2470",
        "castle-cove": "2069",
        "castle-hill": "2154",
        "casuarina": "2487",
        "casula": "2170",
        "catherine-field": "2557",
        "cattai": "2756",
        "caves-beach": "2281",
        "centennial-park": "2021",
        "cessnock": "2325",
        "charlestown": "2290",
        "charmhaven": "2263",
        "chatswood": "2067",
        "chatswood-west": "2067",
        "cherrybrook": "2126",
        "chester-hill": "2162",
        "chinderah": "2487",
        "chippendale": "2008",
        "chipping-norton": "2170",
        "chiswick": "2046",
        "chullora": "2190",
        "claremont-meadows": "2747",
        "clarence-town": "2321",
        "clemton-park": "2206",
        "clovelly": "2031",
        "coal-point": "2283",
        "cobar": "2835",
        "coffs-harbour": "2450",
        "collaroy": "2097",
        "collaroy-plateau": "2097",
        "concord": "2137",
        "concord-west": "2138",
        "condell-park": "2200",
        "connells-point": "2221",
        "coogee": "2034",
        "coolamon": "2701",
        "coonabarabran": "2357",
        "cooranbong": "2265",
        "cootamundra": "2590",
        "coraki": "2471",
        "corowa": "2646",
        "corrimal": "2518",
        "cowra": "2794",
        "cranebrook": "2749",
        "cremorne": "2090",
        "cromer": "2099",
        "cronulla": "2230",
        "crookwell": "2583",
        "crows-nest": "2065",
        "croydon": "2132",
        "daceyville": "2032",
        "dapto": "2530",
        "darlinghurst": "2010",
        "darlington": "2008",
        "dee-why": "2099",
        "denham-court": "2565",
        "deniliquin": "2710",
        "diamond-beach": "2430",
        "doonside": "2767",
        "doyalson": "2262",
        "drummoyne": "2047",
        "dubbo": "2830",
        "dulwich-hill": "2203",
        "dungog": "2420",
        "dural": "2158",
        "earlwood": "2206",
        "east-albury": "2640",
        "east-gosford": "2250",
        "east-hills": "2213",
        "east-lismore": "2480",
        "east-maitland": "2323",
        "eastern-creek": "2766",
        "eastgardens": "2036",
        "eastlakes": "2018",
        "eastwood": "2122",
        "edensor-park": "2176",
        "edgeworth": "2285",
        "edmondson-park": "2174",
        "elanora-heights": "2101",
        "elderslie": "2570",
        "elermore-vale": "2287",
        "emu-plains": "2750",
        "engadine": "2233",
        "epping": "2121",
        "erina": "2250",
        "erskineville": "2043",
        "ettalong-beach": "2257",
        "ewingsdale": "2481",
        "fairfield": "2165",
        "fairfield-heights": "2165",
        "faulconbridge": "2776",
        "fennell-bay": "2283",
        "figtree": "2525",
        "finley": "2713",
        "five-dock": "2046",
        "forbes": "2871",
        "forest-lodge": "2037",
        "forestville": "2087",
        "forster": "2428",
        "frenchs-forest": "2086",
        "garden-suburb": "2289",
        "gateshead": "2290",
        "georges-hall": "2198",
        "gerringong": "2534",
        "gilgandra": "2827",
        "girraween": "2145",
        "gladesville": "2111",
        "glebe": "2037",
        "glen-innes": "2370",
        "glendenning": "2761",
        "glenhaven": "2156",
        "glenmore-park": "2745",
        "glenorie": "2157",
        "glenroy": "2640",
        "glenwood": "2768",
        "googong": "2620",
        "gosford": "2250",
        "goulburn": "2580",
        "grafton": "2460",
        "granville": "2142",
        "green-valley": "2168",
        "greenacre": "2190",
        "gregory-hills": "2557",
        "greystanes": "2145",
        "griffith": "2680",
        "guildford-west": "2161",
        "gunnedah": "2380",
        "guyra": "2365",
        "gymea": "2227",
        "haberfield": "2045",
        "hamilton": "2303",
        "hamilton-north": "2292",
        "harrington-park": "2567",
        "harris-park": "2150",
        "haymarket": "2000",
        "heatherbrae": "2324",
        "hobartville": "2753",
        "holroyd": "2142",
        "homebush": "2140",
        "homebush-west": "2140",
        "hornsby": "2077",
        "hornsby-heights": "2077",
        "hunters-hill": "2110",
        "hurlstone-park": "2193",
        "hurstville": "2220",
        "ingleburn": "2565",
        "inverell": "2360",
        "islington": "2296",
        "jamisontown": "2750",
        "jannali": "2226",
        "jerrabomberra": "2619",
        "jindabyne": "2627",
        "kahibah": "2290",
        "kangy-angy": "2258",
        "karuah": "2324",
        "katoomba": "2780",
        "keiraville": "2500",
        "kellyville": "2155",
        "kelso": "2795",
        "kemps-creek": "2178",
        "kempsey": "2440",
        "kensington": "2033",
        "kenthurst": "2156",
        "kew": "2439",
        "kiama": "2533",
        "killara": "2071",
        "kincumber": "2251",
        "kings-park": "2148",
        "kingscliff": "2487",
        "kingsford": "2032",
        "kingsgrove": "2208",
        "kingswood": "2747",
        "kirrawee": "2232",
        "kogarah": "2217",
        "kooringal": "2650",
        "kotara": "2289",
        "kotara-south": "2289",
        "kurnell": "2231",
        "kurri-kurri": "2327",
        "lake-albert": "2650",
        "lake-heights": "2502",
        "lake-illawarra": "2528",
        "lakemba": "2195",
        "lane-cove": "2066",
        "lane-cove-north": "2066",
        "lane-cove-west": "2066",
        "laurieton": "2443",
        "lavington": "2641",
        "lawson": "2783",
        "leichhardt": "2040",
        "lennox-head": "2478",
        "leppington": "2179",
        "leumeah": "2560",
        "leura": "2780",
        "lidcombe": "2141",
        "lindfield": "2070",
        "lismore": "2480",
        "lithgow": "2790",
        "liverpool": "2170",
        "lockhart": "2656",
        "londonderry": "2753",
        "long-jetty": "2261",
        "lugarno": "2210",
        "lurnea": "2170",
        "maclean": "2463",
        "macquarie-park": "2113",
        "maitland": "2320",
        "maitland-vale": "2320",
        "malua-bay": "2536",
        "manilla": "2346",
        "manly": "2095",
        "manly-vale": "2093",
        "maroubra": "2035",
        "marrickville": "2204",
        "marsden-park": "2765",
        "marsfield": "2122",
        "mascot": "2020",
        "matraville": "2036",
        "mayfield-west": "2304",
        "mays-hill": "2145",
        "medowie": "2318",
        "menai": "2234",
        "merimbula": "2548",
        "merrylands": "2160",
        "metford": "2323",
        "middle-cove": "2068",
        "miller": "2168",
        "millers-point": "2000",
        "millingandi": "2549",
        "milperra": "2214",
        "milsons-point": "2061",
        "minchinbury": "2770",
        "minto": "2566",
        "miranda": "2228",
        "mittagong": "2575",
        "mona-vale": "2103",
        "moonee-beach": "2450",
        "moorebank": "2170",
        "moree": "2400",
        "morisset": "2264",
        "mortdale": "2223",
        "moruya": "2537",
        "mosman": "2088",
        "moss-vale": "2577",
        "mount-annan": "2567",
        "mount-colah": "2079",
        "mount-druitt": "2770",
        "mount-kuring-gai": "2080",
        "mount-olive": "2330",
        "mount-pritchard": "2170",
        "mount-victoria": "2786",
        "mudgee": "2850",
        "mulgrave": "2756",
        "mullumbimby": "2482",
        "murrumbateman": "2582",
        "murwillumbah": "2484",
        "muswellbrook": "2333",
        "narellan": "2567",
        "narellan-vale": "2567",
        "narooma": "2546",
        "narrabeen": "2101",
        "narrawallee": "2539",
        "narraweena": "2099",
        "narromine": "2821",
        "narwee": "2209",
        "nelson-bay": "2315",
        "nemingha": "2340",
        "neutral-bay": "2089",
        "new-lambton": "2305",
        "newcastle": "2300",
        "newcastle-west": "2302",
        "newtown": "2042",
        "niagara-park": "2250",
        "nimbin": "2480",
        "north-avoca": "2260",
        "north-bondi": "2026",
        "north-curl-curl": "2099",
        "north-kellyville": "2155",
        "north-lismore": "2480",
        "north-narrabeen": "2101",
        "north-nowra": "2541",
        "north-parramatta": "2151",
        "north-richmond": "2754",
        "north-rocks": "2151",
        "north-rothbury": "2335",
        "north-ryde": "2113",
        "north-strathfield": "2137",
        "north-sydney": "2060",
        "north-willoughby": "2068",
        "north-wollongong": "2500",
        "northbridge": "2063",
        "northmead": "2152",
        "norwest": "2153",
        "nowra": "2541",
        "oak-flats": "2529",
        "oatley": "2223",
        "oberon": "2787",
        "ocean-shores": "2483",
        "oran-park": "2570",
        "orange": "2800",
        "orchard-hills": "2748",
        "ourimbah": "2258",
        "paddington": "2021",
        "padstow": "2211",
        "pagewood": "2035",
        "pambula": "2549",
        "panania": "2213",
        "parkes": "2870",
        "parramatta": "2150",
        "peak-hill": "2869",
        "peakhurst": "2210",
        "pemulwuy": "2145",
        "pennant-hills": "2120",
        "penrith": "2750",
        "penshurst": "2222",
        "petersham": "2049",
        "picton": "2571",
        "plumpton": "2761",
        "point-clare": "2250",
        "port-kembla": "2505",
        "port-macquarie": "2444",
        "portland": "2847",
        "potts-point": "2011",
        "prairiewood": "2176",
        "prestons": "2170",
        "prospect": "2148",
        "punchbowl": "2196",
        "pymble": "2073",
        "pyrmont": "2009",
        "quakers-hill": "2763",
        "queanbeyan": "2620",
        "raleigh": "2454",
        "ramsgate": "2217",
        "ramsgate-beach": "2217",
        "randwick": "2031",
        "rathmines": "2283",
        "raymond-terrace": "2324",
        "redfern": "2016",
        "redhead": "2290",
        "regents-park": "2143",
        "revesby": "2212",
        "rhodes": "2138",
        "richmond": "2753",
        "riverstone": "2765",
        "robin-hill": "2795",
        "rockdale": "2216",
        "rodd-point": "2046",
        "rooty-hill": "2766",
        "ropes-crossing": "2760",
        "rose-bay": "2029",
        "rosebery": "2018",
        "rosehill": "2142",
        "rosemeadow": "2560",
        "roseville": "2069",
        "roseville-chase": "2069",
        "rouse-hill": "2155",
        "rozelle": "2039",
        "russell-vale": "2517",
        "rutherford": "2320",
        "rydalmere": "2116",
        "ryde": "2112",
        "sadleir": "2168",
        "salamander-bay": "2317",
        "sandgate": "2304",
        "sans-souci": "2219",
        "scone": "2337",
        "seaforth": "2092",
        "sefton": "2162",
        "seven-hills": "2147",
        "shalvey": "2770",
        "shellharbour": "2529",
        "shoalhaven-heads": "2535",
        "silverwater": "2128",
        "singleton": "2330",
        "smeaton-grange": "2567",
        "smithfield": "2164",
        "south-albury": "2640",
        "south-granville": "2142",
        "south-kempsey": "2440",
        "south-lismore": "2480",
        "south-murwillumbah": "2484",
        "south-nowra": "2541",
        "south-penrith": "2750",
        "south-wentworthville": "2145",
        "south-windsor": "2756",
        "spring-farm": "2570",
        "springwood": "2777",
        "st-helens-park": "2560",
        "st-ives": "2075",
        "st-ives-chase": "2075",
        "st-leonards": "2065",
        "st-marys": "2760",
        "st-peters": "2044",
        "stanmore": "2048",
        "stockton": "2295",
        "strathfield": "2135",
        "summer-hill": "2130",
        "surry-hills": "2010",
        "sussex-inlet": "2540",
        "sutherland": "2232",
        "swansea": "2281",
        "sydenham": "2044",
        "sydney": "2000",
        "sydney-olympic-park": "2127",
        "sylvania": "2224",
        "taminda": "2340",
        "tamworth": "2340",
        "tanilba-bay": "2319",
        "taree": "2430",
        "taren-point": "2229",
        "tathra": "2550",
        "temora": "2666",
        "tempe": "2044",
        "tenambit": "2323",
        "tenterfield": "2372",
        "terranora": "2486",
        "terrey-hills": "2084",
        "terrigal": "2260",
        "the-entrance": "2261",
        "the-junction": "2291",
        "the-ponds": "2769",
        "the-rocks": "2000",
        "thirroul": "2515",
        "thora": "2454",
        "thornleigh": "2120",
        "thornton": "2322",
        "tighes-hill": "2297",
        "toongabbie": "2146",
        "toormina": "2452",
        "toronto": "2283",
        "toukley": "2263",
        "townsend": "2463",
        "tuggerah": "2259",
        "tumbi-umbi": "2261",
        "tumut": "2720",
        "tuross-head": "2537",
        "turramurra": "2074",
        "tweed-heads": "2485",
        "tweed-heads-south": "2486",
        "tyagarah": "2481",
        "ulladulla": "2539",
        "ultimo": "2007",
        "umina-beach": "2257",
        "unanderra": "2526",
        "valley-heights": "2777",
        "vincentia": "2540",
        "vineyard": "2765",
        "wagga-wagga": "2650",
        "wahroonga": "2076",
        "waitara": "2077",
        "wakeley": "2176",
        "walgett": "2832",
        "wallabi-point": "2430",
        "wallsend": "2287",
        "wamberal": "2260",
        "warabrook": "2304",
        "waratah": "2298",
        "wareemba": "2046",
        "warners-bay": "2282",
        "warragamba": "2752",
        "warrawong": "2502",
        "warriewood": "2102",
        "warwick-farm": "2170",
        "waterloo": "2017",
        "wattle-grove": "2173",
        "waverton": "2060",
        "wellington": "2820",
        "wentworth": "2648",
        "wentworth-falls": "2782",
        "wentworth-point": "2127",
        "wentworthville": "2145",
        "werrington": "2747",
        "werrington-county": "2747",
        "werrington-downs": "2747",
        "west-gosford": "2250",
        "west-pennant-hills": "2125",
        "west-ryde": "2114",
        "westmead": "2145",
        "wetherill-park": "2164",
        "wickham": "2293",
        "willoughby": "2068",
        "windale": "2306",
        "windang": "2528",
        "windsor": "2756",
        "wingham": "2429",
        "winmalee": "2777",
        "wollongbar": "2477",
        "wollongong": "2500",
        "woolgoolga": "2456",
        "woollahra": "2025",
        "woolloomooloo": "2011",
        "woolooware": "2230",
        "woonona": "2517",
        "woy-woy": "2256",
        "wyoming": "2250",
        "wyong": "2259",
        "yagoona": "2199",
        "yamba": "2464",
        "yass": "2582",
        "yeoval": "2868",
        "young": "2594",
        "zetland": "2017",
    }),
    "vic": Object.freeze({
        "abbotsford": "3067",
        "aberfeldie": "3040",
        "aintree": "3336",
        "airport-west": "3042",
        "albanvale": "3021",
        "albert-park": "3206",
        "alexandra": "3714",
        "alphington": "3078",
        "altona-meadows": "3028",
        "altona-north": "3025",
        "anglesea": "3230",
        "armadale": "3143",
        "ascot-vale": "3032",
        "ashburton": "3147",
        "ashwood": "3147",
        "aspendale-gardens": "3195",
        "avondale-heights": "3034",
        "bairnsdale": "3875",
        "balaclava": "3183",
        "ballarat-central": "3350",
        "ballarat-north": "3350",
        "balwyn-north": "3104",
        "bannockburn": "3331",
        "bayswater": "3153",
        "bayswater-north": "3153",
        "beaconsfield": "3807",
        "beaconsfield-upper": "3808",
        "beaufort": "3373",
        "beaumaris": "3193",
        "belgrave": "3160",
        "belmont": "3216",
        "bendigo": "3550",
        "bentleigh": "3204",
        "bentleigh-east": "3165",
        "berwick": "3806",
        "blackburn": "3130",
        "blackburn-north": "3130",
        "bonbeach": "3196",
        "boronia": "3155",
        "box-hill": "3128",
        "box-hill-north": "3129",
        "box-hill-south": "3128",
        "braeside": "3195",
        "braybrook": "3019",
        "breakwater": "3219",
        "bright": "3741",
        "brighton": "3186",
        "brighton-east": "3187",
        "broadmeadows": "3047",
        "brookfield": "3338",
        "brown-hill": "3350",
        "brunswick": "3056",
        "brunswick-east": "3057",
        "brunswick-west": "3055",
        "bulleen": "3105",
        "bundoora": "3083",
        "burnside": "3023",
        "burwood": "3125",
        "burwood-east": "3151",
        "camberwell": "3124",
        "campbellfield": "3061",
        "canterbury": "3126",
        "carlton": "3053",
        "carlton-north": "3054",
        "carnegie": "3163",
        "caroline-springs": "3023",
        "carrum-downs": "3201",
        "castlemaine": "3450",
        "caulfield": "3162",
        "caulfield-east": "3145",
        "caulfield-north": "3161",
        "caulfield-south": "3162",
        "chelsea": "3196",
        "chelsea-heights": "3196",
        "cheltenham": "3192",
        "chirnside-park": "3116",
        "christmas-hills": "3775",
        "clayton": "3168",
        "clayton-south": "3169",
        "clifton-hill": "3068",
        "clyde": "3978",
        "clyde-north": "3978",
        "coburg": "3058",
        "coburg-north": "3058",
        "colac": "3250",
        "colac-east": "3250",
        "collingwood": "3066",
        "coolaroo": "3048",
        "cowes": "3922",
        "craigieburn": "3064",
        "cranbourne": "3977",
        "cranbourne-east": "3977",
        "cranbourne-south": "3977",
        "cranbourne-west": "3977",
        "cremorne": "3121",
        "croydon": "3136",
        "croydon-north": "3136",
        "cudgee": "3265",
        "dandenong": "3175",
        "dandenong-south": "3175",
        "darley": "3340",
        "delacombe": "3356",
        "dennington": "3280",
        "derrimut": "3026",
        "diamond-creek": "3089",
        "dingley-village": "3172",
        "docklands": "3008",
        "donald": "3480",
        "doncaster-east": "3109",
        "donvale": "3111",
        "doreen": "3754",
        "dromana": "3936",
        "drouin": "3818",
        "drysdale": "3222",
        "eaglehawk": "3556",
        "eastwood": "3875",
        "echuca": "3564",
        "edithvale": "3196",
        "elsternwick": "3185",
        "eltham": "3095",
        "eltham-north": "3095",
        "elwood": "3184",
        "emerald": "3782",
        "endeavour-hills": "3802",
        "epping": "3076",
        "essendon": "3040",
        "essendon-fields": "3041",
        "essendon-north": "3041",
        "eumemmerring": "3177",
        "eynesbury": "3338",
        "fairfield": "3078",
        "fawkner": "3060",
        "ferntree-gully": "3156",
        "fitzroy": "3065",
        "fitzroy-north": "3068",
        "footscray": "3011",
        "forest-hill": "3131",
        "frankston": "3199",
        "geelong": "3220",
        "geelong-west": "3218",
        "gembrook": "3783",
        "gisborne": "3437",
        "gladstone-park": "3043",
        "glen-huntly": "3163",
        "glen-iris": "3146",
        "glen-waverley": "3150",
        "glengarry": "3854",
        "glenroy": "3046",
        "golden-gully": "3555",
        "golden-point": "3350",
        "golden-square": "3555",
        "greensborough": "3088",
        "grovedale": "3216",
        "hadfield": "3046",
        "hallam": "3803",
        "hamilton": "3300",
        "hamlyn-heights": "3215",
        "hampton": "3188",
        "hampton-east": "3188",
        "harkaway": "3806",
        "hastings": "3915",
        "hawthorn": "3122",
        "hawthorn-east": "3123",
        "healesville": "3777",
        "heathcote": "3523",
        "heatherton": "3202",
        "heathmont": "3135",
        "heidelberg": "3084",
        "heidelberg-heights": "3081",
        "heidelberg-west": "3081",
        "highett": "3190",
        "hillside": "3037",
        "hoppers-crossing": "3029",
        "horsham": "3400",
        "hughesdale": "3166",
        "huntingdale": "3166",
        "ironbark": "3550",
        "ivanhoe": "3079",
        "ivanhoe-east": "3079",
        "kallista": "3791",
        "kealba": "3021",
        "keilor-east": "3033",
        "keilor-park": "3042",
        "kensington": "3031",
        "kew": "3101",
        "kew-east": "3102",
        "keysborough": "3173",
        "kialla": "3631",
        "kilmore-east": "3764",
        "kilsyth": "3137",
        "kilsyth-south": "3137",
        "kings-park": "3021",
        "kingsbury": "3083",
        "knoxfield": "3180",
        "korumburra": "3950",
        "kyneton": "3444",
        "lake-gardens": "3355",
        "lakes-entrance": "3909",
        "lalor": "3075",
        "lang-lang": "3984",
        "langwarrin": "3910",
        "lara": "3212",
        "launching-place": "3139",
        "laverton": "3028",
        "laverton-north": "3026",
        "leongatha": "3953",
        "leopold": "3224",
        "lilydale": "3140",
        "lower-plenty": "3093",
        "lynbrook": "3975",
        "macleod": "3085",
        "maddingley": "3340",
        "maidstone": "3012",
        "malvern": "3144",
        "malvern-east": "3145",
        "manor-lakes": "3024",
        "mansfield": "3722",
        "maryborough": "3465",
        "mckinnon": "3204",
        "melbourne": "3000",
        "melton": "3337",
        "melton-south": "3338",
        "melton-west": "3337",
        "mernda": "3754",
        "mickleham": "3064",
        "mildura": "3500",
        "mill-park": "3082",
        "mirboo-north": "3871",
        "mitcham": "3132",
        "moe": "3825",
        "monbulk": "3793",
        "mont-albert-north": "3129",
        "montmorency": "3094",
        "moolap": "3224",
        "moonee-ponds": "3039",
        "moorabbin": "3189",
        "mooroolbark": "3138",
        "mordialloc": "3195",
        "mornington": "3931",
        "morwell": "3840",
        "mount-duneed": "3217",
        "mount-eliza": "3930",
        "mount-evelyn": "3796",
        "mount-macedon": "3441",
        "mount-martha": "3934",
        "mount-pleasant": "3350",
        "mount-waverley": "3149",
        "mulgrave": "3170",
        "murrumbeena": "3163",
        "myrtleford": "3737",
        "narre-warren": "3805",
        "narre-warren-south": "3805",
        "newport": "3015",
        "newtown": "3220",
        "nichols-point": "3501",
        "niddrie": "3042",
        "noble-park": "3174",
        "noble-park-north": "3174",
        "norlane": "3214",
        "north-bendigo": "3550",
        "north-geelong": "3215",
        "north-melbourne": "3051",
        "north-wonthaggi": "3995",
        "northcote": "3070",
        "notting-hill": "3168",
        "numurkah": "3636",
        "nunawading": "3131",
        "oakleigh": "3166",
        "oakleigh-east": "3166",
        "oakleigh-south": "3167",
        "ocean-grove": "3226",
        "officer": "3809",
        "ormond": "3204",
        "pakenham": "3810",
        "parkdale": "3195",
        "parkville": "3052",
        "pascoe-vale": "3044",
        "patterson-lakes": "3197",
        "pearcedale": "3912",
        "point-cook": "3030",
        "port-melbourne": "3207",
        "portland": "3305",
        "prahran": "3181",
        "preston": "3072",
        "queenscliff": "3225",
        "ravenhall": "3023",
        "research": "3095",
        "reservoir": "3073",
        "richmond": "3121",
        "riddells-creek": "3431",
        "ringwood": "3134",
        "ringwood-east": "3135",
        "romsey": "3434",
        "rosebud": "3939",
        "rowville": "3178",
        "roxburgh-park": "3064",
        "rye": "3941",
        "sale": "3850",
        "sandringham": "3191",
        "scoresby": "3179",
        "seaford": "3198",
        "seaholme": "3018",
        "sebastopol": "3356",
        "shepparton": "3630",
        "shepparton-east": "3631",
        "skye": "3977",
        "smythes-creek": "3351",
        "somerton": "3062",
        "somerville": "3912",
        "south-geelong": "3220",
        "south-kingsville": "3015",
        "south-melbourne": "3205",
        "south-morang": "3752",
        "south-yarra": "3141",
        "spotswood": "3015",
        "spring-gully": "3550",
        "springvale": "3171",
        "springvale-south": "3172",
        "st-albans": "3021",
        "st-kilda": "3182",
        "st-kilda-east": "3183",
        "stawell": "3380",
        "strathmore-heights": "3041",
        "sunbury": "3429",
        "sunshine": "3020",
        "sunshine-north": "3020",
        "sunshine-west": "3020",
        "surrey-hills": "3127",
        "swan-hill": "3585",
        "sydenham": "3037",
        "tarneit": "3029",
        "taylors-hill": "3037",
        "taylors-lakes": "3038",
        "tecoma": "3160",
        "teesdale": "3328",
        "templestowe": "3106",
        "templestowe-lower": "3107",
        "the-basin": "3154",
        "thomastown": "3074",
        "thornbury": "3071",
        "torquay": "3228",
        "trafalgar": "3824",
        "traralgon": "3844",
        "travancore": "3032",
        "truganina": "3029",
        "tullamarine": "3043",
        "tyers": "3844",
        "upwey": "3158",
        "vermont": "3133",
        "viewbank": "3084",
        "wallan": "3756",
        "wandana-heights": "3216",
        "wandin-north": "3139",
        "wangaratta": "3677",
        "wantirna": "3152",
        "wantirna-south": "3152",
        "warragul": "3820",
        "warrandyte": "3113",
        "warrnambool": "3280",
        "watsonia": "3087",
        "waurn-ponds": "3216",
        "wendouree": "3355",
        "werribee": "3030",
        "west-footscray": "3012",
        "west-melbourne": "3003",
        "westmeadows": "3049",
        "wheelers-hill": "3150",
        "whittlesea": "3757",
        "williamstown": "3016",
        "williamstown-north": "3016",
        "winchelsea": "3241",
        "windsor": "3181",
        "wodonga": "3690",
        "wonga-park": "3115",
        "woodford": "3281",
        "woodstock": "3751",
        "woori-yallock": "3139",
        "wyndham-vale": "3024",
        "yarra-glen": "3775",
        "yarraville": "3013",
        "yarroweyah": "3644",
        "yinnar": "3869",
    }),
});
